// About.js
import React, { useEffect, useState } from "react";
import API from "../api/axios"; // Ajusta la ruta si tu archivo axios está en otra carpeta

const About = () => {
  const [content, setContent] = useState("");
  const [error, setError] = useState("");

  useEffect(() => {
    const fetchAbout = async () => {
      try {
        // Petición GET al backend para obtener el HTML de "Sobre Nosotros".
        const { data } = await API.get("/about");
        setContent(data);
      } catch (err) {
        console.error("Error al obtener contenido de 'Sobre Nosotros':", err);
        setError("Ocurrió un error al cargar el contenido.");
      }
    };

    fetchAbout();
  }, []);

  if (error) {
    return <p className="text-center text-red-500 mt-6">{error}</p>;
  }

  return (
    <div className="container mx-auto">
      {/* Banner (imagen de fondo con texto superpuesto) */}
      <div
        className="relative w-full h-64 bg-cover bg-center"
        style={{
            backgroundImage: `url(${process.env.REACT_APP_BACKEND_URL}/uploads/AboutBanner/about_banner.jpg)`,
        }}
      >
        <div className="absolute inset-0 bg-black bg-opacity-50 flex items-center justify-center">
            <h1 className="text-white text-4xl font-bold">Sobre Nosotros</h1>
        </div>
    </div>


      {/* Contenido principal */}
      <div className="mt-10 px-4 md:px-8">
        {/* Ejemplo de un bloque adicional (Misión, Visión, etc.) */}
        <div className="mb-8 bg-white p-6 rounded shadow-md">
          <h2 className="text-2xl font-semibold mb-4 text-blue-600">Nuestra Misión</h2>
          <p className="text-gray-700 leading-relaxed">
            Brindar la mejor experiencia y calidad para nuestras queridas mascotas, ofreciendo
            productos innovadores, saludables y al alcance de todos.
          </p>
        </div>

        {/* Aquí insertamos el HTML que viene del backend */}
        <div
          className="bg-white p-6 rounded shadow-md leading-relaxed text-gray-700"
          dangerouslySetInnerHTML={{ __html: content }}
        />
      </div>
    </div>
  );
};

export default About;
